import { IAnchorLink } from '@models/IAnchorLink';
import { IImage } from '@models/IImage';
import { ILink } from '@models/ILink';
import { IPricingData } from '@models/IPricingData';
import StickyNavPosition from '@models/enums/StickyNavPositionEnum';
import StickyNavigation from '@molecules/StickyNavigation/StickyNavigation';
import TabbedProductNavigation from '@molecules/TabbedProductNavigation/TabbedProductNavigation';

interface Props {
  readonly title?: string;
  readonly subTitle?: string;
  readonly vatLabel?: string;
  readonly shippingLabel?: string;
  readonly thumbnail?: IImage;
  readonly icon?: IImage;
  readonly buyNowLink?: ILink;
  readonly anchorNavigation: { items: IAnchorLink[] } | null;
  readonly tabbedNavigation: { tabItems: ILink[] } | null;
  readonly pricingData?: IPricingData;
  readonly fromPriceLabel?: string;
  readonly navPosition?: StickyNavPosition.Top | StickyNavPosition.Bottom;
  readonly shouldHavePadding?: boolean;
}

const ProductNavigation = ({
  title,
  subTitle,
  vatLabel,
  shippingLabel,
  thumbnail,
  icon,
  buyNowLink,
  anchorNavigation,
  tabbedNavigation,
  pricingData,
  fromPriceLabel,
  navPosition,
  shouldHavePadding,
}: Props) => {
  const isTabbedNavigation = !!tabbedNavigation?.tabItems;
  const isAnchorNavigation = !!anchorNavigation?.items;

  const sharedProps = {
    buyNowLink,
    fromPriceLabel,
    icon,
    pricingData,
    shippingLabel,
    shouldHavePadding,
    subTitle,
    thumbnail,
    title,
    vatLabel,
  };

  if (isTabbedNavigation)
    return (
      <TabbedProductNavigation
        {...sharedProps}
        tabbedNavigation={tabbedNavigation.tabItems}
      />
    );

  if (isAnchorNavigation)
    return (
      <StickyNavigation
        {...sharedProps}
        navPosition={navPosition}
        anchorNavigationItems={anchorNavigation.items}
      />
    );
};

export default ProductNavigation;
